import Overlay from './components/overlay'
import Animator from './transitions/index.js'

class VoksewebController {
	constructor() {
		this.setupFlipper()
		this.installClickHandler()
		this.setupOverlays()
		this.setupAnimations()
		this.setupCases()
	}

	setupOverlays() {
		new Overlay()
	}

	setupAnimations() {
		new Animator()
	}

	setupAnchorLinks() {
		// Setup smooth scroll to anchors on same page
		const anchorLinks = [].slice.call(document.querySelectorAll('a[href^="#"]'))

		anchorLinks.forEach(link => {
			link.addEventListener('click', function(event) {
				const targetElement = document.querySelector(link.getAttribute('href'))
				if (targetElement) {
					event.preventDefault()
					targetElement.scrollIntoView({ behavior: 'smooth' })
				}
			})
		})
	}

	installClickHandler() {
		document.addEventListener('click', (event) => {
			const target = event.target

			const filterButton = document.querySelector(".categoryfilter button[aria-expanded]")
			if (target === filterButton) {
				const currentState = filterButton.getAttribute('aria-expanded')
				filterButton.setAttribute('aria-expanded', currentState == 'true' ? false : true)
			}
		})
	}

	setupFlipper() {
		window.fc = new FlipperController('.opinions > .inner')
	}

	setupCases() {
		const tiles = Array.from(document.querySelectorAll('.projecttile'))
		tiles.forEach(tile => {
			tile.dataset.connected = true
			tile.addEventListener('click', (event) => {
				const target = event.target
				// We'll land in here when the caselink is triggered as well,
				// let's bypass in that case...
				if (!target.closest('.caselink')) {
					const caselink = target.closest('.projecttile').querySelector('a.caselink')
					if (caselink) {
						event.preventDefault()
						event.stopPropagation()
						caselink.click()
					}
				}
			})
		})

		this.setupCategoryFilter()
	}

	setupCategoryFilter() {
		const filterButton = document.querySelector(".categoryfilter button[aria-expanded]")

		if (filterButton != null) {
			filterButton.setAttribute('aria-expanded', false)
		}
	}

	fixElements() {
		const elems = Array.from(document.querySelectorAll('picture,video,img[srcset]'))
		elems.forEach(elm => elm.outerHTML = elm.outerHTML)
	}
}

window.addEventListener('DOMContentLoaded', (event) => {
	window.app = new VoksewebController()
})

// window.addEventListener('turbo:load', (event) => {
// 	const app = window.app
//
// 	if (app != null) {
// 		app.fixElements()
// 		app.setupAnchorLinks()
// 		app.setupAnimations()
// 	}
// })
